import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

import {LangDto, LangServiceClient} from '@sharedcommon/rest/technical.restservice';
import {ToastService} from '@sharedcommon/services/toast.service';
import {PatchDto, UserDto, UserServiceClient} from '@sharedcommon/rest/identity.restservice';
import {UserService} from '@sharedcommon/services/user.service';
import {ValidationService} from '@sharedcommon/services/validation.service';
import {NeqAbstractFormViewComponent} from '@sharedcommon/components/validation/abstract-form-view.component';

@Component({
  selector: 'neq-user-properties',
  templateUrl: './user-properties.component.html'
})
export class NeqUserPropertiesComponent extends NeqAbstractFormViewComponent implements OnInit, OnChanges {

  @Input() user: UserDto;

  form = new FormGroup({
    familyName: new FormControl({value: '', disabled: true}),
    givenName: new FormControl({value: '', disabled: true}),
    email: new FormControl({value: '', disabled: true}),
    langCode: new FormControl(undefined, [Validators.required]),
    admin: new FormControl(false, [Validators.required]),
    personalDataAcceptance: new FormControl(false)
  });
  langs: LangDto[];

  messageCheckboxTerms: string;
  messageCheckboxPersonalData: string;

  constructor(
    private readonly userServiceClient: UserServiceClient,
    private readonly langService: LangServiceClient,
    private readonly userService: UserService,
    private readonly toastService: ToastService,
    private readonly translationService: TranslateService,
    validationService: ValidationService
  ) {
    super(validationService);
    this.validationService.init();
    this.checkInForm(this.form);
  }

  ngOnInit() {
    this.form.disable();
    this.form.get('langCode').enable();
    this.form.get('personalDataAcceptance').enable();

    this.langService.fetchActive().subscribe(langs => this.langs = langs);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['user']) {
      this.updateForm();
    }
  }

  onFormSubmit() {
    if (this.form.invalid) {
      return;
    }

    const patch: PatchDto<any>[] = [];
    const toastList: Array<string> = [];

    if (this.form.get('personalDataAcceptance').value !== (this.user.personalDataAcceptance !== null)) {
      let valueToSend = [];

      if (this.form.get('personalDataAcceptance').value) {
        this.user.personalDataAcceptance = new Date();
        valueToSend = ["null", new Date()];
      } else {
        this.user.personalDataAcceptance = null;
        valueToSend = ["null", "null"];
      }
      patch.push({op: 'REPLACE', path: '/gdprAccept', value: valueToSend});
      toastList.push(this.translationService.instant('msg.user.properties.updated'));
    }

    if (this.form.get('langCode').value != this.user.langCode) {
      patch.push({op: 'REPLACE', path: '/langCode', value: this.form.get('langCode').value});
      toastList.push(this.translationService.instant('msg.user.account.lang.updated'));
    }

    if (toastList.length > 0) {
      this.userServiceClient.patchCurrentUser(patch).subscribe(() => {
        toastList.length > 1 ? this.toastService.multiToast(toastList) : this.toastService.toast(toastList[0]);

        this.form.markAsPristine();
        this.updateForm();
      });
    }
  }

  private updateForm() {
    if (this.user) {
      this.form.patchValue(this.user);
      this.form.get('personalDataAcceptance').patchValue(this.user.personalDataAcceptance != null);
    } else {
      this.form.reset();
    }
  }

  hasFormModifications(): boolean {
    return this.form.dirty;
  }

  getFormGroup(): FormGroup {
    return this.form;
  }

  ngAfterViewInit() {
    if (this.userService.getUser()?.lang_code?.toLowerCase() == 'fr') {
      this.messageCheckboxTerms = 'J\'accepte les <a href="https://www.compliance.adm.com/documents/terms-of-use/" rel="noopener" target="_blank">Conditions Générales d\'Utilisation</a>, '
      + 'et j\'ai lu et compris la <a href="https://www.compliance.adm.com/documents/privacy-notice-for-apps/" rel="noopener" target="_blank">Confidentialité des données personnelles</a>.';
      this.messageCheckboxPersonalData = 'J\'accepte qu\'ADM puisse stocker, utiliser et traiter mes données personnelles en m\'envoyant des communications ciblées à des fins de prospection.';

    } else {
      this.messageCheckboxTerms = 'I accept the <a href="https://www.compliance.adm.com/documents/terms-of-use/" rel="noopener" target="_blank">Terms of Use</a>, '
      + 'and have read and understood the <a href="https://www.compliance.adm.com/documents/privacy-notice-for-apps/" rel="noopener" target="_blank">Privacy Notice</a>.'
      this.messageCheckboxPersonalData = 'I agree that ADM may store, use and process my personal data by sending me targeted communications for prospecting purposes.';;

    }
  }

}
